<!--
 * @Author: your name
 * @Date: 2021-08-11 16:54:29
 * @LastEditTime: 2021-08-13 18:18:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hpss-ui\src\views\v4ward\fee\propertyChargingBuildingInquiry.vue
-->

<template>
    <div>
        <basic-container>
    <iframe
      width="100%"
      height="900px"
      :src="iframeUrl"
      id="reportFrame"
      frameborder="0"
    ></iframe>
      <!-- <WebReport ref="WebReport" :url="url" :params="params"  /> -->
        </basic-container>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import urlSettings from '@/config/url-settings.js';
import WebReport from '@/components/web-report';
export default {
    components:{WebReport},
    computed: {
    ...mapGetters(['userInfo']),
  },
    data(){
        return {
            iframeUrl:'',
            selectForm:{},
            carParkList:[],
            deptId:'',
            userId:'',
        }
    },
    methods:{
        initData(){
            this.deptId = this.userInfo.dept_id
            this.userId =this.userInfo.user_id
            let path 
            path =
            urlSettings.VUE_APP_BASE_REPORT_URL +
            urlSettings.VUE_APP_ENVIRONMENT +
            `/propertyChargingBuildingInquiry.cpt&deptId=` + this.deptId
            this.iframeUrl = path
         
        },
        search(){
            
        }
    },
    created(){
        this.initData()
    }

}
</script>

<style>

</style>
